import { Select } from '@alicerce/ui';
import { useNavigate } from 'react-router';
import { useSession } from '@/lib/session';

export function TenantSwitcher() {
  const { me, tenantId, selectTenant, impersonating } = useSession();
  const navigate = useNavigate();
  const tenants = me?.tenants ?? [];
  if (impersonating) return <p className="truncate px-2 text-sm font-semibold text-amber-800">Modo suporte</p>;
  if (tenants.length <= 1) {
    return (
      <div className="px-2">
        <p className="text-xs text-muted">Negócio</p>
        <p className="truncate text-sm font-semibold">{tenants[0]?.tradeName ?? 'Gestora'}</p>
      </div>
    );
  }
  return (
    <div>
      <label htmlFor="tenant-switcher" className="sr-only">
        Negócio
      </label>
      <Select
        id="tenant-switcher"
        value={tenantId ?? ''}
        onChange={(e) => {
          if (e.target.value === '__new') navigate('/novo-negocio');
          else {
            selectTenant(e.target.value);
            navigate('/');
          }
        }}
      >
        {tenants.map((t) => (
          <option key={t.tenantId} value={t.tenantId}>
            {t.tradeName}
          </option>
        ))}
        <option value="__new">+ Novo negócio</option>
      </Select>
    </div>
  );
}
